import {drawer} from '@cypro/ui/components'
import {DrawerBody, DrawerFooter, DrawerHeader} from '@cypro/ui/components'
import {useConfirmDeleteUser} from '@/modules/users/api'
import {UserDrawerTabsList} from '@/modules/users/components/user-drawer/tabs-list'
import {AboutTab} from '@/modules/users/components/user-drawer/tabs/about'
import {ActivityTab} from '@/modules/users/components/user-drawer/tabs/activity'
import {GroupAndPermissionsTab} from '@/modules/users/components/user-drawer/tabs/group-and-permissions'
import {UserSummary} from '@/modules/users/components/user-drawer/user-summary'
import {getUserDrawerId} from '@/modules/users/components/user-drawer/util'
import {useCan} from '@/shared/hooks/use-permissions'
import {useUserContext} from '@/shared/contexts'
import {Drawer, Tabs} from '@chakra-ui/react'
import {DeleteResourceButton} from '@cypro/ui/components/ui/delete-resource-button'
import {LinkButton} from '@cypro/ui/components/ui/link-button'
import {toaster} from '@cypro/ui/toaster'
import {useTranslate} from '@tolgee/react'

export function UserDrawer() {
  const {t} = useTranslate('common')
  const {t: tUsers} = useTranslate('users')
  const {user} = useUserContext()
  const deleteUser = useConfirmDeleteUser()
  const canManageUsers = useCan('users.manage')

  async function onDelete() {
    try {
      await deleteUser({id: user.id})
      const drawerId = getUserDrawerId(user.id)
      drawer.close(drawerId)
      toaster.success({title: t('success'), description: t('resource_deleted_successfully')})
    } catch {}
  }

  return (
    <>
      <DrawerHeader>
        <Drawer.Title>{tUsers('user_details')}</Drawer.Title>
      </DrawerHeader>

      <DrawerBody>
        <UserSummary />

        <Tabs.Root defaultValue="about" spaceY="5">
          <UserDrawerTabsList />

          <AboutTab />
          <GroupAndPermissionsTab />
          <ActivityTab />
        </Tabs.Root>
      </DrawerBody>

      {canManageUsers && (
        <DrawerFooter display="flex" justifyContent="space-between">
          <DeleteResourceButton onClick={onDelete} />

          <LinkButton to="/configuration/users/new" search={{userId: user.id}} colorPalette="cyan" data-e2e="edit-user">
            {t('edit')}
          </LinkButton>
        </DrawerFooter>
      )}
    </>
  )
}
